import React, { useState } from 'react'
import { useProfileStore } from '../../../../stores/UserStore';
import { Button, Group, Stack, Tooltip } from '@mantine/core';
import { IconDeviceFloppy, IconTrash, IconX } from '@tabler/icons-react'; import {
    gridColumnDefinitionsSelector,
    gridColumnVisibilityModelSelector,
    useGridSelector,
} from "@mui/x-data-grid-pro";
import { updateProfile } from '../../../../api/UserAPI';
import { notifications } from '@mantine/notifications';
import { useLanguage } from '../../../../stores/LanguageStore';

const SaveListColumnsById = ({ handleClose, list, apiRef }) => {
    const lang = useLanguage(s => s.language)
    const profile = useProfileStore((s) => s.profile);
    const savedListOrder = profile.saved_order?.contact_list_fetch_contacts_order_by_contact_list_id?.[list.id];
    const [loading, setLoading] = useState(false);

    const columnVisibilityModel = useGridSelector(
        apiRef,
        gridColumnVisibilityModelSelector
    );

    const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);

    const handleSave = () => {
        const allColumns = [...columns];

        let newOrder = allColumns.map((column) => column.field);

        let visibleColumns = [];
        allColumns.forEach((column) => {
            if (Object.keys(columnVisibilityModel).includes(column.field)) {
                if (columnVisibilityModel?.[column.field])
                    visibleColumns.push(column.field);
            } else visibleColumns.push(column.field);
        });

        let columnsSize = {};
        columns.forEach((column) => {
            columnsSize[column.field] = column.width;
        });

        const newVisibleColumns = visibleColumns;

        const profile = useProfileStore.getState().profile;
        const setProfile = useProfileStore.getState().setProfile;

        let hidden_columns = columns
            .filter((x) => !newVisibleColumns.includes(x.field))
            .map((x) => x.field);

        const newData = {
            saved_order: {
                ...(profile?.saved_order || {}),
                "contact_list_fetch_contacts_order_by_contact_list_id": {
                    ...(profile?.saved_order?.contact_list_fetch_contacts_order_by_contact_list_id || {}),
                    [list.id]: {
                        hidden_columns: hidden_columns,
                        order_columns: newOrder.filter((x) => x !== "actions"),
                        size_columns: columnsSize,
                    },
                },
            },
        };

        setLoading("save");
        updateProfile(null, newData)
            .then((response) => {
                notifications.show({
                    message: lang.table.toolbar.columns.visibility_saved,
                    color: "tertiary.8",
                });
                setProfile({ ...profile, ...newData });
            })
            .finally(() => setLoading(false));
    };

    const handleDelete = () => {
        const allColumns = [...columns];

        let newOrder = allColumns.map((column) => column.field);

        let visibleColumns = [];
        allColumns.forEach((column) => {
            if (Object.keys(columnVisibilityModel).includes(column.field)) {
                if (columnVisibilityModel?.[column.field])
                    visibleColumns.push(column.field);
            } else visibleColumns.push(column.field);
        });

        let columnsSize = {};
        columns.forEach((column) => {
            columnsSize[column.field] = column.width;
        });

        const newVisibleColumns = visibleColumns;

        const profile = useProfileStore.getState().profile;
        const setProfile = useProfileStore.getState().setProfile;

        let hidden_columns = columns
            .filter((x) => !newVisibleColumns.includes(x.field))
            .map((x) => x.field);

        const newData = {
            saved_order: {
                ...(profile?.saved_order || {}),
                "contact_list_fetch_contacts_order_by_contact_list_id": {
                    ...(profile?.saved_order?.contact_list_fetch_contacts_order_by_contact_list_id || {}),
                    [list.id]: {
                        hidden_columns: hidden_columns,
                        order_columns: newOrder.filter((x) => x !== "actions"),
                        size_columns: columnsSize,
                    },
                },
            },
        };

        delete newData.saved_order.contact_list_fetch_contacts_order_by_contact_list_id[list.id];

        setLoading("delete");
        updateProfile(null, newData)
            .then((response) => {
                notifications.show({
                    message: lang.table.toolbar.columns.visibility_saved,
                    color: "tertiary.8",
                });
                setProfile({ ...profile, ...newData });
            })
            .finally(() => setLoading(false));
    };

    return (
        <Stack gap={"xs"}>
            <Tooltip label={lang.table.toolbar.columns.save_for_list_tooltip} withArrow>
                <Button variant='light' leftSection={<IconDeviceFloppy size={18} />} onClick={handleSave} loading={loading === "save"}>
                    {lang.table.toolbar.columns.save_for_list}
                </Button>
            </Tooltip>

            {
                savedListOrder && (
                    <Tooltip label={lang.table.toolbar.columns.remove_saved_config_tooltip} withArrow>
                        <Button color='red' variant='light' onClick={handleDelete} loading={loading === "delete"} leftSection={<IconX size={18} />}>
                            {lang.table.toolbar.columns.remove_saved_config}
                        </Button>
                    </Tooltip>
                )
            }
        </Stack>
    )
}

export default SaveListColumnsById